<template>
  <div>
    <div class="w-100">
      <div class="container py-4" id="payment-result">
        <!-- HEADER -->
        <CustomHeader :step="data.status && data.status == 'WAITING_PAYMENT_CONFIRMATION' ? 2 : 3"></CustomHeader>
      </div>
    </div>
    <div class="container my-5">
      <div class="row justify-content-center">
        <div class="col-xl-8 col-lg-10 col-12">
          <div class="w-100 radius-12 px-4 py-5 bg-white box-shadow-light-aff border-secondary-t">
            <div class="text-center" v-if="is_load">
              <loader></loader>
            </div>
            <template v-else>
              <ErrorMessage v-if="error != ''" :message="error"></ErrorMessage>
              <template v-else>

                <!-- COMPLETE -->
                <template v-if="data.status == 'COMPLETE' || data.status == 'CANCELLED'">
                  <div class="mb-5 text-center" v-if="data.status == 'COMPLETE'">
                    <img src="../../../assets/img/icon/green-checked-2.png" class="mb-4 img-check">
                    <p class="text-heading-t text-primary-t font-hw mb-0 text-uppercase">{{ $t('ticket.your-booking-complete') }}</p>
                    <p class="mb-0 body-2-2-1 text-ticket mb-3">{{ $t('ticket.thanks-for-order') }}</p>
                    <p class="mb-0 text-24 font-lato text-ticket">{{ $formatCurrency(total.with_surcharge) }}</p>
                  </div>

                  <div class="mb-5 text-center" v-else>
                    <img src="../../../assets/img/icon/uncheck.png" class="mb-4 img-check">
                    <p class="text-heading-t text-danger font-hw mb-0 text-uppercase">{{ $t('ticket.your-booking-cancelled') }}</p>
                  </div>

                  <!-- PREVIEW -->
                  <div class="w-100 p-3 border-secondary-t mb-4 radius-6" v-if="data.status == 'COMPLETE'">
                    <div class="row">
                      <div class="col-sm-2 d-sm-inline d-none align-self-center border-r-secondary-t">
                        <div class="h-100 w-100 py-3">
                          <img :src="getMerchant.image_url" width="100%" />
                        </div>
                      </div>
                      <div class="col-sm-8 col-9 align-self-center">
                        <p class="sub-heading-1-2 text-black mb-1">{{ total.qty }} {{ $pluralWord(total.qty,'ticket') }} have been booked</p>
                        <div class="w-100 no-ws mb-1">
                          <p class="mb-0 body-3-3-1 d-inline-block align-middle">{{ $t('ticket.visit-date') }} : </p>
                          <p class="body-3-3-2 text-black mb-0 d-inline-block align-middle ml-1">{{ $formatDate(data.visit_date) }}</p>
                        </div>
                        <div class="w-100 no-ws">
                          <p class="mb-0 body-3-3-1 d-inline-block align-middle">Order ID : </p>
                          <p class="body-3-3-2 text-black mb-0 d-inline-block align-middle ml-1">{{ data.ticket_code }}</p>
                        </div>
                      </div>
                      <div class="col-sm-2 col-3 align-self-center">
                        <qrcode-vue class="text-right" :value="data.ticket_code" :size="60" level="H"></qrcode-vue>
                      </div>
                    </div>
                  </div>
                  
                  <div class="row mb-4">
                    <!-- TICKET -->
                    <div class="col-md-8 col-12 mb-4 mb-md-0">
                      <div class="w-100 border-secondary-t radius-6 h-100 position-relative" :style="{'padding-bottom': total.promotion.amount > 0 ? '130px' : '56.667px'}">
                        <div class="p-3 bg-light-primary-ticket border-b-secondary-t radius-t-6 ">
                          <div class="row no-gutters">
                            <div class="col-8">
                              <p class="mb-0 body-1-4">{{ $t('ticket.ticket') }}</p>
                            </div>
                            <div class="col-4 text-right">
                              <p class="mb-0 body-1-4">{{ $t('ticket.price') }}</p>
                            </div>
                          </div>
                        </div>
                        <div class="p-3">
                          <div class="row no-gutters" v-for="(item,index) in data.ticket_details" :class="{'mb-3': index+1 < data.ticket_details.length }">
                            <div class="col-1 align-self-center">
                              <p class="body-1-2 font-lato mb-0 text-ticket">{{ item.qty }}X</p>
                            </div>
                            <div class="col-7 align-self-center">
                              <div class="pl-mobile">
                                <p class="mb-0 body-2-1">{{ item.product_name }}</p>
                                <p class="mb-0 body-3-3" v-if="item.variant_name != ''">{{ printVariantPax(item) }}</p>
                              </div>
                            </div>
                            <div class="col-4 align-self-center text-right">
                              <p class="mb-0 body-2-1">{{ $formatCurrency(Number(item.price_sell)*item.qty) }}</p>
                            </div>
                          </div>
                        </div>
                        <div class="p-3 border-t-d-secondary-t position-absolute w-100" style="bottom: 0;">
                          <template v-if="total.promotion.amount > 0">
                            <div class="row no-gutters mb-1">
                              <div class="col-8">
                                <p class="mb-0 body-2">{{ $t('ticket.subtotal') }}</p>
                              </div>
                              <div class="col-4">
                                <p class="mb-0 text-14 font-lato text-right text-subcolor">{{ $formatCurrency(total.subtotal) }}</p>
                              </div>
                            </div>
                            <div class="row no-gutters mb-2">
                              <div class="col-8">
                                <p class="mb-0 body-2">{{ $t('ticket.discount') }} ({{ total.promotion.percent }}%)</p>
                              </div>
                              <div class="col-4">
                                <p class="mb-0 text-14 font-lato text-right text-success">- {{ $formatCurrency(total.promotion.amount) }}</p>
                              </div>
                            </div>
                          </template>
                          <div class="row no-gutters">
                            <div class="col-8">
                              <p class="mb-0 body-1-4">{{ $t('ticket.total') }}</p>
                            </div>
                            <div class="col-4">
                              <p class="mb-0 body-1-4 text-right">{{ $formatCurrency(total.price) }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- GUEST DETAIL -->
                    <div class="col-md-4 col-12">
                      <div class="w-100 border-secondary-t radius-6 h-100">
                        <div class="p-3 bg-light-primary-ticket border-b-secondary-t radius-t-6 ">
                          <div class="row no-gutters">
                            <div class="col-12">
                              <p class="mb-0 body-1-4">{{ $t('ticket.guest-detail') }}</p>
                            </div>
                          </div>
                        </div>
                        <div class="p-3">
                          <div class="row no-gutters">
                            <div class="col-12 mb-3">
                              <div class="w-100 pr-3">
                                <p class="mb-0 body-3-3-1">{{ $t('ticket.name') }}</p>
                                <p class="mb-0 body-2-1">{{ data.customer_details.full_name }}</p>
                              </div>
                            </div>
                            <div class="col-12 mb-3">
                              <div class="w-100">
                                <p class="mb-0 body-3-3-1">{{ $t('ticket.country') }}</p>
                                <p class="mb-0 body-2-1">{{ data.customer_details.country }}</p>
                              </div>
                            </div>
                            <div class="col-12 mb-3">
                              <div class="w-100">
                                <p class="mb-0 body-3-3-1">{{ $t('ticket.email') }}</p>
                                <p class="mb-0 body-2-1">{{ data.customer_details.email }}</p>
                              </div>
                            </div>
                            <div class="col-12" v-if="$isNotEmpty(data.customer_details.phone_number)">
                              <div class="w-100">
                                <p class="mb-0 body-3-3-1">{{ $t('ticket.phone-number') }}</p>
                                <p class="mb-0 body-2-1">{{ data.customer_details.phone_number }}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- PAYMENT -->
                  <div class="row" v-if="$isNotEmptyV2(data.payment_details)">
                    <div class="col-12">
                      <div class="w-100 border-secondary-t radius-6 h-100">
                        <div class="p-3 bg-light-primary-ticket border-b-secondary-t radius-t-6 ">
                          <div class="row no-gutters">
                            <div class="col-12">
                              <p class="mb-0 body-1-4">{{ $t('ticket.payment-detail') }}</p>
                            </div>
                          </div>
                        </div>
                        <div class="p-3">
                          <div class="row">
                            <div class="col-lg-4 col-5">
                              <p class="mb-0 body-2-1">{{ $t('ticket.payment-method') }}</p>
                            </div>
                            <div class="col-lg-8 col-7 text-right">
                              <p class="mb-0 body-2-1">{{ data.payment_channel.name }}</p>
                            </div>
                          </div>
                          <div class="w-100 my-3 border-t-d-secondary-t"></div>
                          <div class="row">
                            <div class="col-lg-4 col-5">
                              <p class="mb-0 body-2-1">{{ $t('ticket.payment-time') }}</p>
                            </div>
                            <div class="col-lg-8 col-7 text-right">
                              <p class="mb-0 body-2-1">{{ $formatDateTime(data.payment_details.pay_at) }}</p>
                            </div>
                          </div>
                          <template v-if="Number(data.payment_surcharge) > 0">
                            <div class="w-100 my-3 border-t-d-secondary-t"></div>
                            <div class="row">
                              <div class="col-lg-4 col-5">
                                <p class="mb-0 body-2-1">{{ $t('ticket.payment-surcharge') }}</p>
                              </div>
                              <div class="col-lg-8 col-7 text-right">
                                <p class="mb-0 body-2-1">{{ $formatCurrency(data.payment_surcharge) }}</p>
                              </div>
                            </div>
                          </template>
                          <div class="w-100 my-3 border-t-d-secondary-t"></div>
                          <div class="row">
                            <div class="col-lg-4 col-5">
                              <p class="mb-0 body-2-1">{{ $t('ticket.total-paid') }}</p>
                            </div>
                            <div class="col-lg-8 col-7 text-right">
                              <p class="mb-0 body-2-1">{{ $formatCurrency(total.with_surcharge) }}</p>
                            </div>
                          </div>
                          <div class="w-100 my-3 border-t-d-secondary-t"></div>
                          <div class="row">
                            <div class="col-lg-4 col-5">
                              <p class="mb-0 body-2-1">{{ $t('ticket.payment-status') }}</p>
                            </div>
                            <div class="col-lg-8 col-7 text-right">
                              <p class="mb-0 body-2-4 text-success text-uppercase" v-if="data.status == 'COMPLETE'">{{ $t('ticket.success') }}</p>
                              <p class="mb-0 body-2-4 text-danger text-uppercase" v-if="data.status == 'CANCELLED'">{{ $t('ticket.cancelled') }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div class="w-100 text-center mt-5" v-if="data.status == 'COMPLETE'">
                    <state-button variant="secondary-outline" size="lg" :click="downloadTicket">{{ $t('ticket.download-ticket') }}</state-button>
                  </div>
                </template>

                <template v-if="data.status == 'WAITING_PAYMENT_CONFIRMATION'">
                  <div class="text-left" v-if="showXenditCreditCardForm">
                    <XenditInputCC
                      :tx_payment="data.payment_details"
                      module_page="TICKET"
                      @done="checkStatus"
                      @done-destroyed="checkStatus"
                      @expired="checkStatus">
                    </XenditInputCC>
                  </div>
                  
                  <template v-else>
                    <VirtualAccount v-if="data.payment_details.payment_method == 'VIRTUAL_ACCOUNT'" :data="data" module_page="TICKET" :customer_detail="data.customer_details"></VirtualAccount>
                    <Qris 
                      v-if="data.payment_details.payment_method == 'QRIS'"
                      :data="data"
                      module_page="TICKET"
                      :customer_detail="data.customer_detail" />
                    <div class="w-100 text-center mt-5">
                      <p class="body-2-4 mb-3">{{$t("hotel.waiting.already-made-a-payment")}}</p>
                      <state-button variant="primary-ticket" size="lg" :click="checkStatus">{{$t("hotel.waiting.check-payment-status")}}</state-button>
                      <p class="body-2-4 text-danger mb-0 mt-2" v-if="payment_still_not_complete">{{$t("hotel.waiting.payment-still-not-processed")}}</p>
                    </div>
                  </template>
                </template>
              </template>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100">
      <!-- FOOTER -->
      <CustomFooter></CustomFooter>
    </div>
  </div>
</template>

<script>
  import CustomHeader from '../../../components/ticket/CustomHeader';
  import CustomFooter from '../../../components/ticket/CustomFooter';
  import VirtualAccount from '@/components/general/payment/VirtualAccount'
  import Qris from '@/components/general/payment/Qris';
  import XenditInputCC from '@/components/hotel/be/XenditInputCC';
  import { mapGetters } from 'vuex';
  import { get, post } from '@/services/index'
  import QrcodeVue from 'qrcode.vue'
  import moment from 'moment';

  export default {
    components:{
      CustomHeader,
      CustomFooter,
      VirtualAccount,
      Qris,
      QrcodeVue,
      XenditInputCC
    },
    data() {
      return {
        is_load: true,
        error: '',
        data: {},
        payment_still_not_complete: false
      }
    },
    computed:{
      ...mapGetters(['getMerchant']),
      tx_order_id(){
        return this.$route.params.tx_order_id
      },
      total(){
        let return_data = {
          qty: 0,
          subtotal: 0,
          promotion: {
            amount: 0,
            percent: 0
          },
          price: 0,
          with_surcharge: 0,
        }
        if(!this.is_load && this.error == ''){
          this.data.ticket_details.forEach(item=>{
            return_data.subtotal += Number(item.price_sell) * item.qty
            return_data.promotion.amount += Math.abs(Number(item.discount))
            return_data.qty += item.qty
            return_data.price += Number(item.best_price.final_price)*item.qty
          })
          return_data.promotion.percent = this.$getPercentage(return_data.subtotal, return_data.promotion.amount)
          return_data.with_surcharge = Number(this.data.total_payment)+Number(this.data.payment_surcharge)
        }
        return return_data
      },
      showXenditCreditCardForm(){
        const isDataEmpty = this.$isEmpty(this.data); 
        if(isDataEmpty) return false;

        const { status, payment_details: { bank_name, payment_channel } } = this.data; 
        const isStatusPendingPayment = status == 'WAITING_PAYMENT_CONFIRMATION';
        const isPaymentCreditCard = payment_channel == 'CREDIT_CARD'
        const isPaymentChannelXendit = bank_name == 'XENDIT' || bank_name == 'XENDIT_INTERNATIONAL'

        return isStatusPendingPayment && isPaymentCreditCard && isPaymentChannelXendit;
      }
    },
    mounted(){
      this.loadFirstData()
    },
    methods:{
      loadFirstData(){
        this.is_load = true
        this.error = ''
        Promise.all([this.loadDetailTrx()])
        .catch(err=>this.error = err)
        .finally(()=>{
          let visit_date = moment(this.data.visit_date,'YYYY-MM-DD').toDate()
          let promo_code = this.data.promotion != null && this.data.promotion.promotion_type == 'PROMO_CODE' ? this.data.promotion.promo_code : ''
          this.$postLog('PAYMENT_RESULT','','First Load',this.data.tx_order_id,visit_date,promo_code)
          this.is_load = false
        })
      },
      loadDetailTrx(export_pdf=false){
        return new Promise((success,fail)=>{
          let params = export_pdf ? {
            export_to: 'pdf'
          } : {}
          get("CORE","tx-ticket-detail/"+this.tx_order_id,params).then(response=>{
            let res = response.data;
            if(export_pdf){
              success(res)
            }else{
              if (res.success) {
                // this.checkVisitorType(res.data);
                const status = res.data.status;
                
                // const url = new URL(window.location.href);
                // const params = url.searchParams;
                
                // const visitorType = params.has("visitor_type") ? params.get("visitor_type") : "kuk";
                if(status === 'COMPLETE' && this.$route.name === 'TicketPaymentForm'){
                  this.$router.push({
                    name: 'TicketPaymentComplete',
                    params:{ 
                      tx_order_id: this.tx_order_id
                    }
                  })
                }
                if(status !== 'COMPLETE' && this.$route.name === 'TicketPaymentComplete'){
                  this.$router.push({
                    name: 'TicketPaymentForm',
                    params:{ 
                      tx_order_id: this.tx_order_id
                    }
                  })
                }
                
                if(res.data.status == 'COMPLETE') this.$smoothScroll('payment-result')
                success(res.data)
                this.data = res.data
                this.data.customer_details.full_name = this.data.customer_details.first_name
                if(this.$isNotEmpty(this.data.customer_details.title)) this.data.customer_details.full_name = `${this.$capitalize(this.data.customer_details.title)}. ${this.data.customer_details.first_name}`
                if(this.$isNotEmpty(this.data.customer_details.last_name)) this.data.customer_details.full_name += ` ${this.data.customer_details.last_name}`
                this.postingToGTMDataLayer(res.data);
              }else{
                fail(res.message)
              }
            }
            
          }).finally(()=>{
            success()
          })
        })
      },
      async postingToGTMDataLayer(transactionDetail){
        const { tx_order_id, status, google_tag_manager_posting_date = null } = transactionDetail
        if(status === 'COMPLETE' && this.$isEmpty(google_tag_manager_posting_date)){
          const response = await post("CORE", `tx-ticket-detail/${tx_order_id}/posting-date`, {posting_date_types: "google_tag_manager"});
          if(response.data.success) this.$sendCustomTicketGTMDataLayer(transactionDetail, "purchase");
        }
      },
      printVariantPax(data){
        let return_data = ''
        data.pax.forEach((x,i)=>{
          return_data += `${x.qty} ${x.name}`
          if(i+1 < data.pax.length){
            return_data += ', '
          }
        })
        
        return return_data
      },
      downloadTicket(){
        return new Promise((success,fail)=>{
         this.loadDetailTrx(true).then(response=>{
          let filename = `${this.getMerchant.name} - ${this.data.ticket_code}.pdf`
          this.$showPDFFile(response, filename, true, false, true)
          success()
         })
        })
      },
      checkStatus(){
        return new Promise((success,fail)=>{
          this.payment_still_not_complete = false
          this.loadDetailTrx()
          .then(res=>{
            if(res.status === 'WAITING_PAYMENT_CONFIRMATION') this.payment_still_not_complete = true
          })
          .finally(()=>success())
        })
      },
      checkVisitorType(transactionDetail){
        const url = new URL(window.location.href);
        const params = url.searchParams;
        
        const setVisitorType = (type) => {
          params.set('visitor_type', type);
          const newUrl = `${url.pathname}?${params.toString()}`;
          window.history.replaceState({}, '', newUrl);
        }
        
        const { product_special = null } = transactionDetail;
        if(this.$isEmpty(product_special)) return setVisitorType("international");
        if(product_special.strict_guest_profile_country === 'Indonesia') return setVisitorType("domestic");

        return setVisitorType("international");
      },
    }
  }
</script>
<style>
  .img-check{
    height: 100px;    
  }
  @media screen and (max-width: 400px){
    .sub-heading-1-2{
      font-size: 14px;
    }
    .pl-mobile{
      padding-left: 10px;
    }
    .img-check{
      height: 60px;    
    }
  }
</style>


// WEBPACK FOOTER //
// src/pages/ticket/custom/PaymentResult.vue